export default __webpack_public_path__ + "static/media/modern-calligraphy-desktop.c458847a.png";